import React from 'react';
import { Search } from 'lucide-react';

const STATUS_OPTIONS = [
  { value: '', label: 'Svi statusi' },
  { value: 'otvoreno', label: 'Otvoreno' },
  { value: 'u toku', label: 'U toku' },
  { value: 'zatvoreno', label: 'Zatvoreno' },
];

export default function NegotiationFilters({ search, onSearchChange, statusFilter, onStatusChange }) {
  return (
    <div className="flex flex-col sm:flex-row gap-3 mb-6">
      {/* Search */}
      <div className="relative flex-1">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
        <input
          type="text"
          value={search}
          onChange={(e) => onSearchChange?.(e?.target?.value)}
          placeholder="Pretraži po vaučeru ili korisniku..."
          className="w-full pl-9 pr-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 bg-white text-sm"
        />
      </div>
      {/* Status filter */}
      <select
        value={statusFilter}
        onChange={(e) => onStatusChange?.(e?.target?.value)}
        className="px-3 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 bg-white text-sm text-gray-700"
      >
        {STATUS_OPTIONS?.map(opt => (
          <option key={opt?.value} value={opt?.value}>{opt?.label}</option>
        ))}
      </select>
    </div>
  );
}
